import { render } from "./AllyInterestView.vue?vue&type=template&id=3ef7a922"
import script from "./AllyInterestView.vue?vue&type=script&lang=js"
export * from "./AllyInterestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__